const hashSeed = (seed: string | number): number => {
  if (typeof seed === "number") {
    const normalized = seed >>> 0;
    return normalized || 0x6d2b79f5;
  }

  let hash = 2166136261;
  for (let index = 0; index < seed.length; index += 1) {
    hash ^= seed.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0 || 0x6d2b79f5;
};

export class SeededRng {
  private state: number;

  constructor(seed: string | number) {
    this.state = hashSeed(seed);
  }

  next(): number {
    let value = (this.state += 0x6d2b79f5);
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / 4_294_967_296;
  }

  between(minimum: number, maximum: number): number {
    return minimum + (maximum - minimum) * this.next();
  }

  integer(minimum: number, maximumInclusive: number): number {
    return Math.floor(this.between(minimum, maximumInclusive + 1));
  }

  pick<T>(values: readonly T[]): T {
    if (values.length === 0)
      throw new Error("cannot pick from an empty collection");
    const value = values[this.integer(0, values.length - 1)];
    if (value === undefined)
      throw new Error("seeded random index was out of bounds");
    return value;
  }
}
